




































import Vue from 'vue'
import oldstyle from '../style.module.scss'
import newstyle from '../newstyle.module.scss'

import renderer from './renderer'

import { TableRow, CellHeader } from '@/types/table'

export default Vue.extend({
    name: 'simple-table',
    components: {
        renderer
    },
    props: {
        headers: Array as () => CellHeader[],
        rows: Array as () => TableRow[],
        typeCode: String,
        nameStyle: {
            type: String,
            required: false
        },
        emptyMessage:String
    },
    data() {
        return {
            style: this.nameStyle === 'old' ? oldstyle : newstyle
        }
    },
    methods: {
        getHeaderName(header: CellHeader): string {
            if (header.unitName) {
                return header.name + ', ' + header.unitName;
            }
            else {
                return header.name;
            }
        }
    }
})
